module.exports = __webpack_public_path__ + "img/cara1.e22b4db7.jpg";